import { imageForDetectionID } from '@/libraries/api/faces'

export const FaceMaskAlertsModule = {
  namespaced: true,
  state: {
    alerts: [],
  },
  mutations: {
    clearAlerts (state) {
      state.alerts = []
    },
    /**
     * Sets the sate to be the passed alerts.
     *
     * @param {object} state The state of the store.
     * @param {array} data A list of alert objects.
     */
    updateAlerts (state, data) {
      console.log('data', data)
      state.alerts = data.sort((a, b) => b.unixTimestamp - a.unixTimestamp)
    },
  },
  getters: {
    alerts (state) {
      return state.alerts
    },
  },
  actions: {
    transformAlert ({ commit, state }, alert) {
      return new Promise((resolve, reject) => {
        // Pull out some things we need.
        const timestamp = typeof alert.event_ts === 'number' ? alert.event_ts * 1000 : Date.parse(alert.event_ts)
        const isFaceMaskAlert = alert.category === 'face_mask_alert'
        const detectionId = alert.alert_data.detections[0].detection_id
        const confidence = alert.alert_data.detections[0].mask_confidence

        if (isFaceMaskAlert) {
          console.log('Got face mask alert')
          console.log(alert)
          const alertObject = {
            category: alert.category,
            alertId: alert.alert_id,
            unixTimestamp: timestamp.valueOf(),
            posterFrame: imageForDetectionID(detectionId),
            fullFrame: imageForDetectionID(detectionId, { fullFrame: true }),
            cameraDescription: alert.description,
            cameraUUID: alert.camera_uuid,
            frontendFaceUUID: alert.frontend_face_uuid,
            detectionId: detectionId,
            lastSeenTS: timestamp, // ???
            dismissedAt: alert.dismissed_at,
            dismissedBy: alert.dismissed_by_end_user_info,
            confidence,
          }
          resolve(alertObject)
        } else {
          reject(new Error(`Improperly formatted detection...`))
        }
      })
    },
    mergeAlerts ({ commit, state }, { alerts, options }) {
      return new Promise((resolve, reject) => {
        resolve(alerts.filter((alert, index) => {
          return alerts.map(a => a.alertId).indexOf(alert.alertId) === index
        }))
      })
    },
    incomingFaceMaskAlert ({ state, dispatch, commit }, { alert }) {
      return new Promise((resolve, reject) => resolve(dispatch('transformAlert', alert)))
        .then(alert => state.alerts.concat([alert]))
        .then(alerts => dispatch('mergeAlerts', { alerts }))
        .then(alerts => alerts.sort((a, b) => a.unixTimestamp < b.unixTimestamp))
        .then(alerts => commit('updateAlerts', alerts))
        .catch(error => console.log(`Error: `, error))
    },
    clearAlertsData ({ state, commit }) {
      commit('clearAlerts')
    },
  },
}
